import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import AnimatedPlaceholder from '@/components_new/AnimatedPlaceholder.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'TaskWidgetPlaceholder',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createVNode(AnimatedPlaceholder, {
      class: _normalizeClass(_ctx.$style.circle)
    }, null, 8, ["class"]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.verticalGroup)
    }, [
      _createVNode(AnimatedPlaceholder, {
        class: _normalizeClass(_ctx.$style.sausageTop)
      }, null, 8, ["class"]),
      _createVNode(AnimatedPlaceholder, {
        class: _normalizeClass(_ctx.$style.sausageBottom)
      }, null, 8, ["class"])
    ], 2),
    _createVNode(AnimatedPlaceholder, {
      class: _normalizeClass(_ctx.$style.button)
    }, null, 8, ["class"])
  ], 2))
}
}

})